"use client";

import { c as _c } from "react/compiler-runtime";
import { useTransition } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { NL_TIERS, type TierKey } from "../config/leagues";
interface TierTabsProps {
  activeTier: TierKey;
}

/**
 * Pill-style tier switcher. Same visual language as the `MatchTabbedList` pills
 * elsewhere on the site — active pill uses `bg-primary text-primary-foreground`,
 * inactive uses `bg-muted text-muted-foreground`.
 *
 * URL-synced via `?tier=a|b|c|d`; keeps scroll position on swap.
 */
export function TierTabs(t0) {
  const $ = _c(13);
  const {
    activeTier
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const labels = useLabels();
  const [pending, startTransition] = useTransition();
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = slug => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("tier", slug);
      startTransition(() => {
        router.replace(`${pathname}?${params.toString()}`, {
          scroll: false
        });
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const select = t1;
  const t2 = pending || undefined;
  let t3;
  if ($[4] !== activeTier || $[5] !== labels || $[6] !== select) {
    t3 = NL_TIERS.map(t => {
      const isActive = t.tier === activeTier;
      return <button key={t.tier} type="button" role="tab" onClick={() => select(t.slug)} aria-selected={isActive} className={`px-3 sm:px-4 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer ${isActive ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:bg-muted/80"}`}>{labels.nationsLeague.tiers[t.labelKey]}</button>;
    });
    $[4] = activeTier;
    $[5] = labels;
    $[6] = select;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label="Nations League tier">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="max-w-350 mx-auto px-4 pt-6" data-pending={t2}>{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}